// React gadget keys
export const REACT_KEY_FILTER_RESULTS = 'react/filter-results';
const REACT_KEY_ASSIGNED_TO_ME = 'react/assigned-to-me';
const REACT_KEY_ISSUES_IN_PROGRESS = 'react/issues-in-progress';
const REACT_KEY_VOTED_ISSUES = 'react/voted-issues';
const REACT_KEY_WATCHED_ISSUES = 'react/watched-issues';
const REACT_KEY_CUSTOM_REPORT = 'react/custom-report';

export const REACT_KEY = {
	FILTER_RESULTS: REACT_KEY_FILTER_RESULTS,
	ASSIGNED_TO_ME: REACT_KEY_ASSIGNED_TO_ME,
	ISSUES_IN_PROGRESS: REACT_KEY_ISSUES_IN_PROGRESS,
	VOTED_ISSUES: REACT_KEY_VOTED_ISSUES,
	WATCHED_ISSUES: REACT_KEY_WATCHED_ISSUES,
	CUSTOM_REPORT: REACT_KEY_CUSTOM_REPORT,
} as const;
